export const COMPANY = {
  legalName: "Haven and Hill Properties L.L.C",
  brandName: "Haven & Hill Properties",
  email: "support@havenandhillproperties.com",
  whatsapp: "+971 58 812 3628",
  licenseNo: "1241498",
  reraOrn: "38008",
  brokerCard: "",
};

export const LICENSE_LINE = [
  COMPANY.licenseNo && `Trade License No: ${COMPANY.licenseNo}`,
  COMPANY.reraOrn && `RERA ORN: ${COMPANY.reraOrn}`,
  COMPANY.brokerCard && `Broker Card No: ${COMPANY.brokerCard}`,
].filter(Boolean).join(" · ");
